/* eslint-disable react/forbid-dom-props */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
// eslint-disable-next-line import/named
import * as PropTypes from 'prop-types';
import { AppTile } from '@shared/containers/appTile';
import { getUserFavouriteEntityAppType } from '@shared/utils/userFavouriteDedicatedUtils';
import { AppReviewCollection } from '../containers/appReviewCollection';
import Overview from '../containers/overview';
import { routes, urlPush, urlReplace } from '@shared/routerHistory';
import { SpzaInstrumentService } from '@shared/services/telemetry/spza/spzaInstrument';
import { getWindow } from '@shared/services/window';
import { isMSASupported, isTransactApp, isAvailableInThisRegion, getPDPRoute, getGalleryRoute, isPrivateOffer, isMigratedPowerBIVisual, getAppTelemetryDetailContentText, isAppForMSAAccountOnly, isD365App, isD365BCApp, isPowerBIVisualsApp, isBagTransactable, isSignedInChanged, canRenderPricing, getActionStringForCTAType, getProductByUrlKey, getProdcutBitMaskInfo, isCertifiedSoftware } from '@shared/utils/appUtils';
import { Constants, OfferType } from '@shared/utils/constants';
import { DataMap } from '@shared/utils/dataMapping';
import { getPrimaryProductUrl, getProductFilter } from '@shared/utils/datamappingHelpers';
import * as DetailUtils from '@shared/utils/detailUtils';
import { getBillingCountryByCountryCode, getPriceString, getStartingFromPriceText, hidePowerBiVisualPricing } from '@shared/utils/pricing';
import UserFavouriteTileDetailButton from '@shared/containers/userFavouriteTileDetailButton';
import { AppTag, PricingStates, CheckoutSource } from '@shared/Models';
import { InternalLink } from '@shared/components/internalLink';
import { ExternalLink } from '@shared/components/externalLink';
import { SimplePlanPricing } from '@shared/components/simplePlanPricing';
import SpzaComponent from '@shared/components/spzaComponent';
import { Tab, Tabs, SELECTED_TAB_QUERY } from '@shared/components/tabs';
import { TelemetryImage } from '@shared/components/telemetryImage';
import { IconLink } from '@shared/components/iconLink';
import { Card } from '@shared/components/card';
import { ButtonLink } from '@shared/components/ButtonLink';
import { AppDetailsLinkedItems } from '@shared/components/appDetailsLinkedItems';
import { StickyCard } from '@shared/components/stickyCard';
import { UsefulInfo, UsefulInfoMetadataCellItemType } from './UsefulInfo';
import { getWorkBreakEnabledString } from '@shared/utils/stringUtils';
import { BreadcrumbUrl } from '@shared/components/breadcrumbUrl';
import { Icon, mergeStyleSets, Stack, ScreenWidthMinXLarge, ScreenWidthMinXXLarge, PrimaryButton, Text, Spinner } from '@fluentui/react';
import { MicrosoftManagedIndicatorWrapper } from 'components/microsoftManagedIndicatorWrapper';
import { useTelemetry } from '@shared/hooks/useTelemetry';
import { logger } from '@src/logger';
import { CtaButtons } from '@shared/components/ctaButtons';
import { SaasPricingTable } from '@appsource/components';
import { AppDetailsHeaderRatingBar } from '@shared/components/appDetailsHeaderRatingBar';
import { NeutralColors, CommunicationColors } from '@fluentui/theme';
import classNames from 'classnames';
import { isOneTimePaymentOffer } from '@shared/utils/onetimepaymentoffers';
import { UserTerms } from '@appsource/components/userTerms';
import { LinkedinProductGroupBar } from '@appsource/components/linkedin/linkedinProductGroupBar';
import { LinkedinProductGroup } from '@appsource/components/linkedin/linkedinProductGroup';
import noResults from '@shared/images/noResults.svg';
import Badge from '@appsource/components/Badge';
// eslint-disable-next-line react-hooks/rules-of-hooks
const [{ pageAction }] = useTelemetry();
const BI_AREA = 'Private Offer';
const contentStyles = mergeStyleSets({
    pdpDetailsContainer: [
        'pdpDetails',
        {
            padding: 0,
            '@media (min-width: 640px) and (max-width: 1024px)': {
                paddingLeft: '32px !important',
                paddingRight: '32px !important'
            },
            '@media (max-width: 640px)': {
                paddingLeft: '20px !important',
                paddingRight: '20px !important'
            }
        }
    ],
    autoScrollTabContent: {
        overflow: 'auto'
    },
    tabsContainer: {
        display: 'flex',
        [`@media (min-width: ${ScreenWidthMinXLarge}px)`]: {
            flexDirection: 'row'
        },
        [`@media (max-width: ${ScreenWidthMinXLarge - 1}px)`]: {
            flexDirection: 'column-reverse'
        }
    },
    userTermsContainer: {
        backgroundColor: NeutralColors.white,
        border: '1px solid #EAEAEA',
        borderRadius: '2px',
        height: 'fit-content',
        [`@media (max-width: ${ScreenWidthMinXLarge - 1}px)`]: {
            margin: '36 0 24 0'
        },
        [`@media (min-width: ${ScreenWidthMinXLarge - 1}px)`]: {
            marginBottom: 28
        },
        [`@media (min-width: ${ScreenWidthMinXLarge}px) and (max-width: ${ScreenWidthMinXXLarge - 1}px)`]: {
            marginLeft: 40,
            minWidth: 200,
            maxWidth: 200
        },
        [`@media (min-width: ${ScreenWidthMinXXLarge}px)`]: {
            marginLeft: 32,
            minWidth: 256,
            maxWidth: 256
        },
        '& a:link': {
            color: CommunicationColors.primary,
            textDecoration: 'underline'
        },
        '& a:visited': {
            color: CommunicationColors.primary
        },
        '& a:hover': {
            color: CommunicationColors.shade20
        },
        '& a:active': {
            color: CommunicationColors.shade30
        }
    },
    ctaSampleButton: {
        paddingTop: 10,
        '&:active': {
            color: '#323130'
        },
        '&:hover': {
            color: '#323130',
            opacity: '0.7'
        }
    },
    instructionLink: {
        marginTop: '10px !important'
    },
    bagdeContainer: {
        marginTop: '12px'
    }
});
const consentDisclaimerTokens = {
    padding: 16
};
export class AppDetails extends SpzaComponent {
    /** This temporary function blocks pricing for BAG offers that are not yet ready to be transacted. */ shouldBlockPricing() {
        // hasPrices check is necessary to ensure we don't block pricing for valid Dynamics 365 and PBI Visual offers
        const { app } = this.props;
        return [
            isD365App,
            isD365BCApp,
            isPowerBIVisualsApp
        ].some((fn)=>fn(app)) && !isBagTransactable(app) && app.hasPrices;
    }
    getProductFilterListElements(filterItem, filterTileTypes) {
        let primaryProductFilter = null;
        const filteritems = [];
        Object.keys(DataMap.products).map((value)=>{
            var _DataMap_products__match, _DataMap_products_;
            const currentDatamapBlock = DataMap.products[`${value}`];
            if (this.props.app && !currentDatamapBlock.ShortcutFilters && ((_DataMap_products_ = DataMap.products[`${value}`]) === null || _DataMap_products_ === void 0 ? void 0 : (_DataMap_products__match = _DataMap_products_.match) === null || _DataMap_products__match === void 0 ? void 0 : _DataMap_products__match.call(_DataMap_products_, this.props.app))) {
                const filter = currentDatamapBlock;
                if (!filter) {
                    return null;
                }
                const pathParams = {
                    industry: null,
                    category: null,
                    product: null,
                    search: null
                };
                pathParams[`${filterTileTypes}`] = filter.ShortcutUrlKey;
                // we are preselecting L1 product in detail page category redirect link back to gallery page.
                // we are only doing this for primary product now which mean no L2 product will be preselected.
                if (filterTileTypes === Constants.filterTileTypes.category && primaryProductFilter) {
                    pathParams.product = primaryProductFilter.UrlKey;
                }
                const newPath = this.context.buildHref(routes.marketplace, null, pathParams);
                // Temporary fix for PowerApps to have their builtfor displayed as Apps
                // until we come up with the complete design
                const { property, mask } = getProdcutBitMaskInfo(DataMap.products.PowerApps);
                const isPowerApp = filter.UrlKey === 'web-apps' && this.props.app.products[`${property}`] && (this.props.app.products[`${property}`] & mask) > 0;
                if (isPowerApp) {
                    filter.LocKey = 'Apps';
                    filter.LongTitle = 'Apps';
                }
                filteritems.push({
                    filterItem,
                    locKey: filter.LocKey,
                    newPath,
                    title: filter.LongTitle,
                    urlKey: filter.UrlKey
                });
            }
            return null;
        });
        return filteritems;
    }
    showDialog(ctaType) {
        const app = _object_spread_props(_object_spread({}, this.props.app), {
            actionString: getActionStringForCTAType(ctaType)
        });
        this.context.ctaCallback({
            entity: app,
            entityType: Constants.EntityType.App,
            ctaType,
            actionModifier: Constants.Telemetry.ActionModifier.AppDetailCTAButton,
            hasLicense: this.props.doesTenantHasLicenseForApp,
            isOpenedFromPDP: true,
            ribbonKey: this.props.ribbonKey
        });
    }
    fetchData(nextProps) {
        if (nextProps.entityId) {
            const { entityId, isPrivate } = nextProps;
            const { arm } = this.props.userInfo.accessToken;
            // If it private, we must have ARM token ready
            if (isPrivate && arm) {
                this.props.ensureAsyncData({
                    entityId,
                    isPrivate
                });
            } else if (!isPrivate) {
                this.props.ensureAsyncData({
                    entityId,
                    isPrivate
                });
            }
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.fetchData(nextProps);
    }
    componentDidMount() {
        this.fetchData(this.props);
        const { entityId, app, loadLinkedInProductGroup } = this.props;
        if (loadLinkedInProductGroup) {
            loadLinkedInProductGroup({
                legacyOfferId: entityId
            });
        }
        if (app) {
            this.telemetryPageLoad();
            // User profile isn't being loaded so we can send the log
            if (!this.props.isLoadingUserProfile) {
                this.logPageLoadAfterUserLoaded();
            }
            this.openRatingModal();
        }
        if (getWindow()) {
            getWindow().addEventListener('scroll', this.handleScroll.bind(this));
        }
    }
    componentDidUpdate(prevProps) {
        var _this_props_userInfo;
        const userProfileLoaded = prevProps.isLoadingUserProfile && !this.props.isLoadingUserProfile;
        if (userProfileLoaded && !this.state.pageLoadLogged) {
            this.logPageLoadAfterUserLoaded();
        }
        if (isSignedInChanged((_this_props_userInfo = this.props.userInfo) === null || _this_props_userInfo === void 0 ? void 0 : _this_props_userInfo.signedIn, prevProps.userInfo.signedIn)) {
            var _this_props_app;
            const entityId = ((_this_props_app = this.props.app) === null || _this_props_app === void 0 ? void 0 : _this_props_app.entityId) || this.props.entityId;
            const { arm } = this.props.userInfo.accessToken;
            const { isPrivate } = this.props;
            this.props.fetchUserPrivateOffers();
            if (!this.props.app && arm) {
                // If it is a private app, the n app will be undefined and we'll need to refetch it from private
                this.props.ensureAsyncData({
                    entityId,
                    isPrivate
                });
            }
            // Get review details
            this.props.ensureAppReviewsData(entityId, true);
        }
        this.handleScroll();
    }
    componentWillUnmount() {
        const curWindow = getWindow();
        if (curWindow) {
            curWindow.removeEventListener('scroll', this.handleScroll.bind(this));
        }
    }
    openRatingModal() {
        if (this.props.location && this.props.location.query && this.props.location.query.survey) {
            const accessKey = this.props.location.query.survey === 'user' ? null : this.props.location.query.survey;
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            this.props.openRatingModal(this.props.app, accessKey, this.props.app.actionString, ()=>{});
        }
    }
    getAllAppsBtn() {
        const seeAllUrl = this.context.buildHref(routes.marketplace, null, {
            category: null,
            industry: null,
            product: null,
            search: null
        });
        return /*#__PURE__*/ _jsx(InternalLink, {
            className: "allAppsButton",
            href: seeAllUrl,
            accEnabled: true,
            "aria-label": `${BI_AREA} see all apps`,
            "data-bi-name": `${BI_AREA} See all apps button`,
            "data-bi-area": BI_AREA,
            children: this.context.loc('ValueProposition_ActionBanner_Button', 'See all apps')
        });
    }
    renderEmptyPrivatePage() {
        const itemAlignmentsStackTokens = {
            childrenGap: 28,
            padding: 10
        };
        return /*#__PURE__*/ _jsx("div", {
            className: "privateOffersContainer",
            children: /*#__PURE__*/ _jsx("div", {
                className: "emptyGalleryWrapper",
                children: /*#__PURE__*/ _jsxs(Stack, {
                    tokens: itemAlignmentsStackTokens,
                    children: [
                        /*#__PURE__*/ _jsx(Stack.Item, {
                            align: "center",
                            children: /*#__PURE__*/ _jsx("img", {
                                className: "noResultsImg",
                                src: noResults,
                                alt: this.context.loc('UserPrivateOffer_No_Results', 'No results')
                            })
                        }),
                        /*#__PURE__*/ _jsx(Stack.Item, {
                            align: "center",
                            children: /*#__PURE__*/ _jsx(Text, {
                                variant: "large",
                                children: this.context.loc('UserPrivateOffer_Pdp_NoAccess', "You don't have access to this private plan.")
                            })
                        }),
                        /*#__PURE__*/ _jsx(Stack.Item, {
                            align: "center",
                            children: /*#__PURE__*/ _jsx(ExternalLink, {
                                "aria-label": this.context.loc('App_LearnMore', 'Learn more'),
                                "data-bi-name": `${BI_AREA} learn more button`,
                                "data-bi-area": BI_AREA,
                                accessibilityEnabled: true,
                                href: "https://go.microsoft.com/fwlink/?linkid=2162844",
                                shouldOpenInTab: true,
                                children: this.context.loc('App_LearnMore', 'Learn more')
                            })
                        }),
                        /*#__PURE__*/ _jsx(Stack.Item, {
                            align: "center",
                            children: this.getAllAppsBtn()
                        })
                    ]
                })
            })
        });
    }
    logPageLoadAfterUserLoaded() {
        var _getWindow_location;
        const { app: appInfo, currentView, doesTenantHasLicenseForApp, nationalCloud, uiRole, billingCountryCode, isEmbedded } = this.props;
        const { entityId: appName, ctaTypes } = appInfo || {};
        const payload = {
            page: (_getWindow_location = getWindow().location) === null || _getWindow_location === void 0 ? void 0 : _getWindow_location.href,
            action: Constants.Telemetry.Action.PageLoad,
            actionModifier: Constants.Telemetry.ActionModifier.End,
            appName,
            details: getAppTelemetryDetailContentText({
                appInfo,
                isNationalCloud: !!nationalCloud,
                isEmbedded,
                ctaTypes,
                currentView,
                uiRole,
                hasLicense: uiRole ? doesTenantHasLicenseForApp : null,
                shouldShowUserTerms: appInfo && billingCountryCode ? DetailUtils.shouldShowUserTerms({
                    app: appInfo,
                    billingCountryCode
                }) : null
            })
        };
        this.instrument.probe('logTelemetryInfo', payload);
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier,
            appName: payload.appName
        });
        this.setState({
            pageLoadLogged: true
        });
    }
    telemetryPageLoad() {
        const { billingCountryCode, ctaTypes, entityId, linkedAddIns, linkedSaaS } = this.props.app;
        if (ctaTypes && isTransactApp({
            isEmbedded: false,
            ctaTypes,
            appData: this.props.app,
            billingRegion: billingCountryCode
        })) {
            pageAction(null, {
                content: {
                    contentType: Constants.JsllSaas.TransactableSaasPdpView
                }
            });
        }
        if (linkedAddIns && linkedAddIns.length > 0) {
            pageAction(null, {
                content: {
                    contentType: Constants.Telemetry.ContentType.SaaSBundlePageView,
                    areaName: Constants.Telemetry.AreaName.AppDetails,
                    contentName: entityId
                }
            });
        } else if (linkedSaaS) {
            pageAction(null, {
                content: {
                    contentType: Constants.Telemetry.ContentType.AddInBundlePageView,
                    areaName: Constants.Telemetry.AreaName.AppDetails,
                    contentName: entityId
                }
            });
        }
    }
    getOfficeWorksWithList(property) {
        const list = DetailUtils.getDetailArrayItem(this.props.app, property);
        if (!Array.isArray(list)) {
            return [];
        }
        return list.filter((item)=>!!Constants.Office365Mapping[`${item}`]).map((item)=>{
            const value = Constants.Office365Mapping[`${item}`];
            // value will be of the form
            // [actualName]
            // [localizationResource, param1, ...] or
            if (value.length === 1) {
                return value[0];
            } else {
                if (Array.isArray(value[1])) {
                    return this.context.locParams(value[0], value[1]);
                } else {
                    return this.context.locParams(value[0], [
                        value[1]
                    ]);
                }
            }
        });
    }
    checkDup(res, item) {
        for(let i = 0; i < res.length; i++){
            const existAward = res[`${i}`];
            if (existAward.length === item.length && existAward.every(function(v, j) {
                return v === item[`${j}`];
            })) {
                return true;
            }
        }
        return false;
    }
    getOfficeAwards(awardKeys) {
        const res = [];
        for(let i = 0; i < awardKeys.length; i++){
            const award = Constants.OfficeAwardsMapping[awardKeys[`${i}`]];
            if (award) {
                if (i === 0) {
                    res.push(award);
                } else {
                    if (!this.checkDup(res, award)) {
                        res.push(award);
                    }
                }
            }
        }
        return res;
    }
    isLatestAppAward(awardKeys) {
        for(let i = 0; i < awardKeys.length; i++){
            const award = Constants.OfficeAwardsMapping[awardKeys[`${i}`]];
            if (award && award[2] === this.context.loc('Latest_App_Awards_Year')) {
                return true;
            }
        }
        return false;
    }
    isPowerBICertifiedApp(keys) {
        for(let i = 0; i < keys.length; i++){
            const key = keys[`${i}`];
            if (AppTag[`${key}`] === AppTag.PowerBICertified) {
                return true;
            }
        }
        return false;
    }
    isMSPApp() {
        return this.props.app.tags && this.props.app.tags.indexOf(Constants.BadgeType.AzureExpertsMSP) >= 0;
    }
    getBreadcrumbElement() {
        const { hideBreadcrumbUrl } = this.props;
        const { href, locKey } = getGalleryRoute(this.props.app.appType);
        const linksList = [
            {
                locKey
            },
            {
                locKey: this.props.app.title
            }
        ];
        return /*#__PURE__*/ _jsx(BreadcrumbUrl, {
            href: this.context.buildHref(href, null, {}),
            linksList: linksList,
            hideBreadcrumbUrl: hideBreadcrumbUrl
        });
    }
    getIconElement() {
        const iconUri = DetailUtils.getDetailInformation(this.props.app, 'LargeIconUri');
        if (!iconUri) {
            return /*#__PURE__*/ _jsx("div", {
                className: "iconHost"
            });
        }
        let iconBackgroundColor = DetailUtils.getDetailInformation(this.props.app, 'IconBackgroundColor');
        if (!iconBackgroundColor) {
            iconBackgroundColor = this.props.app.iconBackgroundColor;
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: "iconHost",
            style: {
                backgroundColor: iconBackgroundColor
            },
            children: [
                /*#__PURE__*/ _jsx("span", {
                    className: "thumbnailSpacer"
                }),
                /*#__PURE__*/ _jsx(TelemetryImage, {
                    src: iconUri,
                    className: "appLargeIcon",
                    itemPropName: "image",
                    title: this.props.app ? this.props.app.title : ''
                })
            ]
        });
    }
    getCTAElement() {
        const { setCheckoutSourcePDP } = this.props;
        return /*#__PURE__*/ _jsx(CtaButtons, {
            app: this.props.app,
            billingCountryCode: this.props.billingCountryCode,
            startingPrice: this.props.startingPrice,
            isLoadingUserData: this.props.isLoadingUserData,
            onCTAClick: (ctaType)=>{
                setCheckoutSourcePDP({
                    source: CheckoutSource.PdpTop
                });
                this.showDialog(ctaType);
            },
            isEmbedded: false,
            openInNewWindowButtonFlag: this.props.openInNewWindowButtonFlag
        });
    }
    getDownloadSampleButton() {
        if (!this.props.app.downloadSampleLink) {
            return null;
        }
        const { app: { entityId } } = this.props;
        return /*#__PURE__*/ _jsx(PrimaryButton, {
            className: classNames([
                contentStyles.ctaSampleButton,
                'CTAbutton',
                'downloadSampleButton'
            ]),
            name: "downloadSampleButton",
            href: this.props.app.downloadSampleLink,
            target: "_self",
            "data-bi-id": Constants.JsllCTAId.DownloadSample,
            "data-bi-type": Constants.JsllCTAId.DownloadSample,
            "data-bi-name": entityId,
            onClick: ()=>{
                const payload = {
                    page: getWindow().location.href,
                    action: Constants.Telemetry.Action.Click,
                    actionModifier: Constants.Telemetry.ActionModifier.DownloadPBIVisualSample,
                    appName: this.props.entityId
                };
                this.instrument.probe(Constants.Telemetry.ProbeName.LogInfo, payload);
                logger.info('', {
                    action: payload.action,
                    actionModifier: payload.actionModifier,
                    appName: payload.appName
                });
            },
            children: this.context.loc('DownloadSample', 'Download Sample')
        }, this.props.app.downloadSampleLink);
    }
    getInstructionsButton() {
        const linkTitle = 'Instructions';
        return /*#__PURE__*/ _jsx(InternalLink, {
            role: "link",
            onClick: this.openInstructionsModal,
            className: classNames([
                contentStyles.instructionLink,
                'c-hyperlink instructionsButton'
            ]),
            telemetryDetails: linkTitle,
            children: this.context.loc('Instructions', linkTitle)
        });
    }
    getNotAvailableInRegionText() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "notAvailableInRegionContainer",
            children: [
                /*#__PURE__*/ _jsx("span", {
                    className: "icon-info-14"
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: "notAvailableInRegionText",
                    children: this.context.loc('NotAvailableInBillingRegion', 'Not available in selected billing region')
                })
            ]
        });
    }
    getUserFavouriteButton() {
        const app = this.props.app;
        if (!app || isPrivateOffer(this.props.app.appType)) {
            return null;
        }
        return /*#__PURE__*/ _jsx(UserFavouriteTileDetailButton, {
            entityId: app.entityId,
            entityType: getUserFavouriteEntityAppType(),
            item: app
        });
    }
    getMicrosoftManagedIndicator() {
        const { indicatorText, indicatorClasses, iconName, iconClasses } = this.getMicrosoftManagedIndicatorUiVariables();
        if (indicatorText) {
            return /*#__PURE__*/ _jsxs("div", {
                className: "microsoftManagedIndicator",
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        iconName: iconName,
                        className: iconClasses
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: indicatorClasses,
                        children: indicatorText
                    })
                ]
            });
        }
        return null;
    }
    getMicrosoftManagedIndicatorUiVariables() {
        const indicator = {
            indicatorText: '',
            indicatorClasses: '',
            iconName: '',
            iconClasses: ''
        };
        if (isD365BCApp(this.props.app)) {
            indicator.indicatorText = this.context.loc('MicrosoftManagedIndicator_D365BC');
            indicator.indicatorClasses = 'indicatorText';
            indicator.iconName = 'Info';
            indicator.iconClasses = 'indicatorIcon';
        } else if (isD365App(this.props.app)) {
            indicator.indicatorText = this.context.loc('MicrosoftManagedIndicator_D365_NotAdmin');
            indicator.indicatorClasses = 'indicatorText';
            indicator.iconName = 'Info';
            indicator.iconClasses = 'indicatorIcon';
        }
        return indicator;
    }
    renderBadge(name) {
        return /*#__PURE__*/ _jsx(Badge, {
            name: name
        });
    }
    handleBadgeClick(contentName) {
        const payload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.Click,
            actionModifier: Constants.Telemetry.ActionModifier.Info,
            details: JSON.stringify({
                contentName
            })
        };
        this.instrument.probe('logTelemetryInfo', payload);
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier
        });
    }
    // TODO: move to utils
    hasOfficeAwards() {
        if (this.props.app.awards) {
            const awards = this.getOfficeAwards(this.props.app.awards);
            if (awards && awards.length > 0) {
                return true;
            }
        }
        if (this.props.app.entityId.toUpperCase() === Constants.HyperfishEntityId.toUpperCase()) {
            const awards = this.getOfficeAwards([
                'AppAwards_2018_BestUX_Place2'
            ]);
            if (awards && awards.length > 0) {
                return true;
            }
        }
        return false;
    }
    // TODO: move to utils
    isPBICertified() {
        if (this.props.app.tags) {
            if (this.isPowerBICertifiedApp(this.props.app.tags)) {
                return true;
            }
        }
        return false;
    }
    // TODO: move to utils
    isMicrosoftCertified() {
        if (this.props.app.CertificationState === Constants.CertificationType.MicrosoftCertified) {
            return true;
        }
        return false;
    }
    // TODO: move to utils
    isFreeTrial() {
        var _app_startingPrice, _app_pricingInformation;
        const { app } = this.props;
        if (app.actionString === Constants.ActionStrings.Try) {
            return true;
        }
        if ((_app_startingPrice = app.startingPrice) === null || _app_startingPrice === void 0 ? void 0 : _app_startingPrice.hasFreeTrial) {
            return true;
        }
        if (app.trials === DataMap.trials['free-trial'].FilterID) {
            return true;
        }
        // vm
        if ((_app_pricingInformation = app.pricingInformation) === null || _app_pricingInformation === void 0 ? void 0 : _app_pricingInformation.skus) {
            const length = app.pricingInformation.skus.length;
            // loop through all skus to see if any of them have a free trial days duration
            for(let i = 0; i < length; i++){
                const sku = app.pricingInformation.skus[`${i}`];
                if (sku.freeTrialDurationDays) {
                    return true;
                }
            }
        }
        return false;
    }
    renderLinkedItems(app, nationalCloud) {
        let dataBiId = '';
        let productId = '';
        let isSaaSRendering = false;
        let headerString = '';
        if (app.linkedSaaS) {
            isSaaSRendering = true;
            dataBiId = 'View Parent';
            productId = DataMap.products.AzureforWebApps.UrlKey;
        } else if (app.linkedAddIns && app.linkedAddIns.length > 0) {
            dataBiId = 'View AddIn';
            productId = DataMap.products.Office365.UrlKey;
        }
        headerString = isSaaSRendering ? this.context.loc('Saas_Linking_App_Details_Parent_Title', 'For the full capabilities of this add-in, get the SaaS package:') : this.context.loc('Saas_Linking_App_Details_AddIns_Title', 'This app package includes premium versions of these add-ins:');
        return /*#__PURE__*/ _jsx(AppDetailsLinkedItems, {
            headerString: headerString,
            linkedItems: isSaaSRendering ? this.props.parentApps : this.props.linkedAddIns,
            isSaaSRendering: isSaaSRendering,
            productId: productId,
            dataBiId: dataBiId,
            nationalCloud: nationalCloud,
            app: app,
            billingCountryCode: this.props.billingCountryCode,
            isLoadingUserData: this.props.isLoadingUserData,
            locale: this.props.locale
        });
    }
    renderLinkedAddIns() {
        if (this.props.app.linkedAddIns && this.props.app.linkedAddIns.length) {
            return /*#__PURE__*/ _jsxs("div", {
                className: "addInsContainer",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "addInsHeader",
                        children: this.context.loc('Saas_Linking_App_Details_AddIns_Title', 'This SaaS package includes full capability versions of these add-ins:')
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: this.props.app.linkedAddIns.map((addIn)=>/*#__PURE__*/ _jsx(InternalLink, {
                                href: this.context.buildHref(this.getPDProute(), {
                                    productId: DataMap.products.Office365.UrlKey,
                                    entityId: addIn.entityId
                                }, {
                                    tab: 'Overview'
                                }),
                                "data-bi-id": "viewAddIn",
                                "data-bi-area": Constants.Telemetry.AreaName.AppDetails,
                                "data-bi-view": "SaaSBundle",
                                name: 'LinkedAddIn-' + addIn.type,
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: 'addInsIcon ms-BrandIcon--icon48 ms-BrandIcon--' + addIn.type
                                })
                            }, addIn.entityId))
                    })
                ]
            });
        }
    }
    renderAlreadyPurchased() {
        if (this.props.app.ctaTypes && this.props.app.ctaTypes.some((ctaType)=>ctaType === Constants.CTAType.Purchase)) {
            return /*#__PURE__*/ _jsxs("div", {
                className: "alreadyPurchasedContainer",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "alreadyPurchasedLabel",
                        children: this.context.locParams('Saas_Linking_App_Details_Already_Title', [
                            this.props.app.title
                        ])
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        className: "alreadyPurchasedButton",
                        onClick: ()=>this.showDialog(Constants.CTAType.AlreadyPurchased),
                        children: this.context.loc('Saas_Linking_App_Details_Already_Button')
                    })
                ]
            });
        }
    }
    renderRatings() {
        return /*#__PURE__*/ _jsx(AppDetailsHeaderRatingBar, {
            app: this.props.app
        });
    }
    renderLinkedIn() {
        const { linkedInProductGroup, locale, billingCountryCode } = this.props;
        return linkedInProductGroup && /*#__PURE__*/ _jsx(LinkedinProductGroupBar, {
            linkedInProductGroup: linkedInProductGroup,
            locale: locale,
            countryCode: billingCountryCode
        });
    }
    getDetailCellElement(information, headerContent, itemPropName) {
        const microTaggingItemPropName = itemPropName || '';
        if (information) {
            if (microTaggingItemPropName === 'publisher') {
                return /*#__PURE__*/ _jsxs("div", {
                    className: "cell",
                    itemProp: microTaggingItemPropName,
                    itemScope: true,
                    itemType: "https://schema.org/Organization",
                    children: [
                        /*#__PURE__*/ _jsx("header", {
                            role: "complementary",
                            "aria-label": headerContent,
                            children: headerContent
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            itemProp: "name",
                            children: information
                        })
                    ]
                });
            } else {
                return /*#__PURE__*/ _jsxs("div", {
                    className: "cell",
                    itemProp: microTaggingItemPropName,
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            role: "complementary",
                            "aria-label": headerContent,
                            children: headerContent
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            children: information
                        })
                    ]
                });
            }
        } else {
            return null;
        }
    }
    // Refactor Candidate: Consider using detailsUtils.getDetailHyperlinkElement
    getDetailHyperlinkElement(information, id, locString) {
        if (information) {
            return /*#__PURE__*/ _jsx("a", {
                className: "c-hyperlink",
                rel: "noreferrer",
                target: "_blank",
                href: information,
                title: locString,
                onClick: ()=>{
                    DetailUtils.generateLinkPayloadAndLogTelemetry(DetailUtils.OwnerType.App, this.props.app.entityId, id, information, 'Default');
                },
                children: locString
            });
        } else {
            return null;
        }
    }
    changeTabCallback(tabTitle) {
        const newPath = this.getTabHref(tabTitle);
        urlReplace(newPath);
    }
    getPDProute() {
        return getPDPRoute(this.props.app.appType);
    }
    getTabHref(tabTitle) {
        const productString = getPrimaryProductUrl(this.props.app.primaryProduct);
        const productData = getProductByUrlKey({
            urlKey: productString
        });
        const product = productData ? productData.UrlKey : productString;
        return this.context.buildHref(this.getPDProute(), {
            productId: product,
            entityId: this.props.app.entityId
        }, {
            tab: tabTitle
        }, true, false, true);
    }
    getStartingPriceElement(startingPrice, isDetailed = false) {
        const { app, billingCountryCode, app: { entityId } } = this.props;
        if (startingPrice && startingPrice.pricingData && startingPrice.pricingData !== PricingStates.NoPricingData && startingPrice.pricingData !== PricingStates.NotAvailableInThisRegion && startingPrice.pricingData !== PricingStates.AlwaysAvailable && startingPrice.pricingData !== PricingStates.Loading) {
            const pricingElement = {
                type: null,
                label: '',
                value: '',
                href: ''
            };
            if (startingPrice.pricingData === PricingStates.FreeApp) {
                pricingElement.type = Constants.ButtonType.Label;
                pricingElement.label = this.context.loc('Pricing');
                pricingElement.value = this.context.loc('Pricing_Free');
            } else if (startingPrice.pricingData === PricingStates.AdditionalPurchasesRequired) {
                pricingElement.type = Constants.ButtonType.Label;
                pricingElement.label = this.context.loc('Pricing');
                pricingElement.value = this.context.loc('AdditionalPurchaseMayBeRequired');
            } else if (startingPrice.pricingData === PricingStates.StartFromFree) {
                // Freemium offers with pricing plans
                pricingElement.type = Constants.ButtonType.Label;
                pricingElement.label = this.context.loc('Pricing_StartsAt');
                pricingElement.value = this.context.loc(!this.shouldBlockPricing() && isDetailed ? 'Pricing_StartsFromFree' : 'Pricing_Free');
            } else if (startingPrice.pricingData === PricingStates.BYOL) {
                Object.assign(pricingElement, {
                    type: Constants.ButtonType.Label,
                    label: this.context.loc('Pricing'),
                    value: this.context.loc('Bring_Your_Own_License')
                });
            } else if (typeof startingPrice.pricingData === 'object') {
                if (this.canRenderPricing()) {
                    const isOneTimePayment = isOneTimePaymentOffer(entityId);
                    pricingElement.href = this.getTabHref(AppDetails.pricingTabName);
                    pricingElement.type = Constants.ButtonType.Link;
                    pricingElement.label = this.context.loc('StartingAt');
                    pricingElement.value = getStartingFromPriceText({
                        startingPrice,
                        offerType: app.offerType,
                        context: this.context,
                        countryCode: billingCountryCode,
                        isOneTimePaymentOffer: isOneTimePayment,
                        locale: this.props.locale
                    });
                } else {
                    pricingElement.type = Constants.ButtonType.Label;
                    pricingElement.label = this.context.loc('Pricing');
                    pricingElement.value = getPriceString({
                        context: this.context,
                        price: startingPrice.pricingData,
                        countryCode: this.props.billingCountryCode,
                        currency: startingPrice.pricingData.currency,
                        locale: this.props.locale
                    });
                }
            }
            if (typeof startingPrice.pricingData === 'object' && !this.canRenderPricing()) {
                if (pricingElement.value) {
                    pricingElement.value = pricingElement.value + ' ' + this.context.loc('SiteLicenseAlsoAvailable');
                } else {
                    pricingElement.type = Constants.ButtonType.Label;
                    pricingElement.label = this.context.loc('Pricing');
                    pricingElement.value = this.context.loc('SiteLicenseAlsoAvailable');
                }
            }
            return pricingElement;
        }
        return null;
    }
    bulidStartingPriceElement({ pricingLinkClassName }) {
        const { app, isEmbedded } = this.props;
        const startingPrice = this.shouldBlockPricing() ? null : this.props.startingPrice;
        const pricingElement = this.getStartingPriceElement(startingPrice);
        if (pricingElement) {
            return /*#__PURE__*/ _jsx("div", {
                className: "cell",
                itemProp: "offers",
                itemScope: true,
                itemType: "https://schema.org/Offer",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "pricingText",
                    children: [
                        pricingElement && pricingElement.label && pricingElement.type && pricingElement.value && !hidePowerBiVisualPricing({
                            app,
                            isEmbedded
                        }) ? /*#__PURE__*/ _jsx(ButtonLink, {
                            href: pricingElement.href ? pricingElement.href : '',
                            className: pricingLinkClassName,
                            type: pricingElement.type,
                            accEnabled: true,
                            label: pricingElement.label,
                            value: pricingElement.value
                        }) : null,
                        startingPrice.pricingData === PricingStates.FreeApp ? /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("meta", {
                                    itemProp: "price",
                                    content: "0"
                                }),
                                /*#__PURE__*/ _jsx("meta", {
                                    itemProp: "priceCurrency",
                                    content: "USD"
                                }),
                                /*#__PURE__*/ _jsx("meta", {
                                    itemProp: "category",
                                    content: "free"
                                })
                            ]
                        }) : typeof startingPrice.pricingData === 'object' ? /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("meta", {
                                    itemProp: "priceCurrency",
                                    content: startingPrice.pricingData.currency
                                }),
                                /*#__PURE__*/ _jsx("meta", {
                                    itemProp: "price",
                                    content: getPriceString({
                                        context: this.context,
                                        price: startingPrice.pricingData,
                                        countryCode: this.props.billingCountryCode,
                                        currency: startingPrice.pricingData.currency,
                                        locale: this.props.locale
                                    }).replace(/[^0-9.]/g, '')
                                })
                            ]
                        }) : null
                    ]
                })
            });
        }
        return null;
    }
    renderAADWorkAccountMetaData() {
        const appData = this.props.app;
        const primaryProduct = appData && appData.primaryProduct;
        const products = appData && appData.products;
        const ctaTypes = appData && appData.ctaTypes || [];
        const shouldRenderAADWorkAccountMetaData = ctaTypes.some((ctaType)=>{
            return !isAppForMSAAccountOnly(primaryProduct, products, ctaType);
        });
        return shouldRenderAADWorkAccountMetaData && 'SignInModal_AccountType2';
    }
    buildFilterElements(filteritems) {
        if (filteritems) {
            let filterElements = filteritems.map((filter)=>{
                if (this.props.nationalCloud) {
                    return /*#__PURE__*/ _jsx("div", {
                        children: this.context.loc(filter.locKey, filter.title)
                    }, filter.title);
                } else {
                    return /*#__PURE__*/ _jsx(IconLink, {
                        iconClassName: 'icon-' + filter.urlKey + '-16',
                        href: filter.newPath,
                        title: this.context.loc(filter.locKey, filter.title),
                        onClick: (e)=>{
                            DetailUtils.generateLinkPayloadAndLogTelemetry(DetailUtils.OwnerType.App, this.props.app.entityId, filter.filterItem, filter.newPath, 'Default');
                            urlPush(filter.newPath);
                            window.scrollTo(0, 0);
                            // The preventDefault prevents the route from transitioning and thus refreshing the page.
                            e.preventDefault();
                        },
                        accEnabled: true,
                        className: "c-hyperlink detailsCategories",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "productItem",
                            children: [
                                this.context.loc(filter.locKey, filter.title),
                                filter.filterItem === Constants.filterMaps.categories ? /*#__PURE__*/ _jsx("meta", {
                                    itemProp: "applicationCategory",
                                    content: this.context.loc(filter.locKey, filter.title)
                                }) : null
                            ]
                        })
                    }, filter.title);
                }
            });
            filterElements = filterElements.filter((element)=>!!element);
            return filterElements;
        }
        return null;
    }
    /** Returns Plans + Pricing tab if any SKUs have a price, otherwise returns Plans tab */ getPlanAndPricingTabTitle() {
        var _this_props_app_pricingInformation_skus, _this_props_app_pricingInformation;
        if (!this.shouldBlockPricing() && ((_this_props_app_pricingInformation = this.props.app.pricingInformation) === null || _this_props_app_pricingInformation === void 0 ? void 0 : (_this_props_app_pricingInformation_skus = _this_props_app_pricingInformation.skus) === null || _this_props_app_pricingInformation_skus === void 0 ? void 0 : _this_props_app_pricingInformation_skus.some((sku)=>!!sku.startingPrice))) {
            return this.context.loc('Detail_PlansPricingTab');
        }
        return this.context.loc('Detail_PlansTab');
    }
    renderReviewsTab() {
        return /*#__PURE__*/ _jsx(AppReviewCollection, {
            appId: this.props.app.entityId,
            appData: this.props.app,
            location: this.props.location,
            isEmbed: false
        });
    }
    renderOverviewTab() {
        const { app, billingCountryCode, suggestedItems } = this.props;
        const { ctaTypes, detailInformation, entityId, offerType, products, shortDescription, tags, title, autoRunLaunchEvents } = app;
        const isOneTimePayment = isOneTimePaymentOffer(entityId);
        return /*#__PURE__*/ _jsx(Overview, {
            isOneTimePayment: isOneTimePayment,
            ownerType: DetailUtils.OwnerType.App,
            ownerId: entityId,
            ownerTitle: title,
            products: products,
            shortDescription: shortDescription,
            description: detailInformation.Description,
            images: detailInformation.Images,
            videos: detailInformation.DemoVideos,
            capabilities: DetailUtils.getDetailArrayItem(app, 'Capabilities'),
            autoRunLaunchEvents: autoRunLaunchEvents,
            TileType: AppTile,
            crossListings: suggestedItems,
            isPowerBICertified: tags ? this.isPowerBICertifiedApp(tags) : null,
            isSaaSTransactableApp: offerType === OfferType.SaaSApp ? isTransactApp({
                isEmbedded: false,
                ctaTypes,
                appData: app,
                billingRegion: billingCountryCode
            }) ? Constants.JsllSaas.SaasTransactable : Constants.JsllSaas.SaasNonTransactable : ''
        });
    }
    renderLinkedinTab() {
        const { linkedInProductGroup, app, locale, billingCountryCode, userInfo: { email: userEmail, signedIn: userSignedIn } } = this.props;
        return /*#__PURE__*/ _jsx(LinkedinProductGroup, {
            linkedInProductGroup: linkedInProductGroup,
            offerName: app.title,
            countryCode: billingCountryCode,
            locale: locale,
            userEmail: userSignedIn ? userEmail : null,
            feedbackScoreRequired: true,
            parentTabQuery: SELECTED_TAB_QUERY
        });
    }
    getTabChildren() {
        const tabsChilds = [
            {
                title: this.context.loc('PartnerDetail_OverviewTab', 'Overview'),
                name: Constants.Tabs.Overview,
                getContent: ()=>this.renderOverviewTab()
            }
        ];
        if (this.canRenderPricing()) {
            tabsChilds.push({
                title: this.getPlanAndPricingTabTitle(),
                name: AppDetails.pricingTabName,
                getContent: ()=>this.renderPricing()
            });
        }
        const usefulInfo = ()=>this.props.isHydrated && /*#__PURE__*/ _jsx(UsefulInfo, {
                ownerType: DetailUtils.OwnerType.App,
                metadata: this.getUsefulInfoMetadata(this.props.app)
            });
        const { app: { entityId = '' } } = this.props;
        const isOneTimePayment = isOneTimePaymentOffer(entityId);
        if (!isOneTimePayment) {
            tabsChilds.push({
                title: this.context.loc('AppDetail_ReviewsTab', 'Ratings + reviews'),
                name: Constants.Tabs.Reviews,
                getContent: ()=>this.renderReviewsTab()
            });
        }
        tabsChilds.push({
            title: this.context.loc('AppDetail_DetilsAndSupportTab', 'Details + support'),
            name: Constants.Tabs.DetailsAndSupport,
            getContent: usefulInfo
        });
        const { linkedInProductGroup } = this.props;
        if (linkedInProductGroup) {
            tabsChilds.push({
                title: this.context.loc('AppDetail_LinkedinTab', 'LinkedIn community'),
                name: Constants.Tabs.Linkedin,
                textBadge: this.context.loc('New', 'New'),
                getContent: ()=>this.renderLinkedinTab()
            });
        }
        return tabsChilds;
    }
    getTabsProps() {
        const tabsProps = {
            defaultTab: this.props.defaultTab,
            ownerType: DetailUtils.OwnerType.App,
            ownerId: this.props.app.entityId,
            changeTabCallback: this.changeTabCallback.bind(this),
            getTabHref: this.getTabHref.bind(this)
        };
        return tabsProps;
    }
    /**
   * Returns the link element for either the publisher's terms of use, the standard contract, or the standard contract
   * with amendments
   */ // TODO - move to utils
    getTermsOfUseLinks() {
        const terms = [
            {
                information: this.props.app.licenseTermsUrl,
                id: 'LicenseAgreement',
                locString: 'App_LicenseAgreement'
            }
        ];
        if (this.props.app.universalAmendmentUrl) {
            terms.push({
                information: this.props.app.universalAmendmentUrl,
                id: 'App_UniversalAmendment',
                locString: 'App_UniversalAmendment'
            });
        }
        return terms;
    }
    canRenderPricing() {
        const { app, billingCountryCode } = this.props;
        return canRenderPricing({
            app,
            isEmbedded: false,
            billingRegion: billingCountryCode
        });
    }
    renderPricing() {
        const { app, billingCountryCode } = this.props;
        const { offerType, pricingInformation, futurePricesInformation, licenseManagement, entityId } = app;
        const billingCountry = getBillingCountryByCountryCode(billingCountryCode);
        if (offerType === OfferType.SaaSApp) {
            return /*#__PURE__*/ _jsx(SaasPricingTable, {
                app: app,
                billingCountry: billingCountry,
                shouldBlockPrices: this.shouldBlockPricing(),
                onGetInNowClicked: this.getItNowTableCallback
            });
        }
        return /*#__PURE__*/ _jsx(SimplePlanPricing, {
            pricing: pricingInformation,
            futurePrices: futurePricesInformation,
            billingCountry: billingCountry,
            isMicrosoftManaged: licenseManagement === null || licenseManagement === void 0 ? void 0 : licenseManagement.isMicrosoftManaged,
            shouldBlockPrices: this.shouldBlockPricing(),
            isOneTimePaymentOffer: isOneTimePaymentOffer(entityId),
            locale: this.props.locale
        });
    }
    // TODO - move to utils
    getUsefulInfoMetadata(app) {
        const { entityId } = this.props;
        const oneTimePaymentOffer = isOneTimePaymentOffer(entityId);
        // colomn 1 - Useful Information
        const usefulInformaionCells = [];
        const supportCells = [];
        const moreLinksCells = [];
        const powerBIVisualCells = [];
        const metadata = [];
        // publisher
        usefulInformaionCells.push({
            id: 'publisher',
            title: 'App_Publisher',
            cellItems: [
                {
                    id: 'publisherItem',
                    type: UsefulInfoMetadataCellItemType.Label,
                    text: app.publisher
                }
            ]
        });
        // MicrosoftCertified
        if (!DetailUtils.hideCertificateBadges()) {
            if (app.CertificationState === Constants.CertificationType.MicrosoftCertified || app.CertificationState === Constants.CertificationType.SelfAttested) {
                usefulInformaionCells.push({
                    id: 'App_Certification',
                    title: 'App_Certification',
                    cellItems: [
                        {
                            id: 'M365ertificationDetails',
                            type: UsefulInfoMetadataCellItemType.Link,
                            text: app.CertificationState === Constants.CertificationType.MicrosoftCertified ? 'App_CertificationLink' : 'App_CertificationLinkSelfAttested',
                            information: app.CertificationLink,
                            entityId: app.entityId
                        }
                    ]
                });
            }
        }
        // pricing
        const isDetailedPricing = true;
        const pricingObject = this.getStartingPriceElement(this.props.startingPrice, isDetailedPricing);
        if (pricingObject) {
            let cell;
            if (pricingObject.type === Constants.ButtonType.Link) {
                cell = {
                    information: pricingObject.href,
                    id: 'SupportLink',
                    text: this.context.locParams('StartingAtPrice', [
                        pricingObject.value
                    ]),
                    type: UsefulInfoMetadataCellItemType.Link,
                    entityId: app.entityId,
                    props: {
                        target: '_self',
                        accEnabled: true
                    }
                };
            } else {
                cell = {
                    id: 'AppVersionItem',
                    type: UsefulInfoMetadataCellItemType.Label,
                    text: pricingObject.value
                };
            }
            usefulInformaionCells.push({
                id: 'Pricing',
                title: 'Pricing',
                cellItems: [
                    cell
                ]
            });
        }
        // aad or microsoft account
        const AADWorkAccount = this.renderAADWorkAccountMetaData();
        usefulInformaionCells.push({
            id: 'Accounts_Supported',
            title: 'Accounts_Supported',
            cellItems: [
                AADWorkAccount && {
                    id: 'AADWorkAccount',
                    type: UsefulInfoMetadataCellItemType.Label,
                    text: AADWorkAccount
                },
                isMSASupported(app.products) && {
                    id: 'MSASupported',
                    type: UsefulInfoMetadataCellItemType.Label,
                    text: 'Microsoft_Account'
                }
            ]
        });
        // app version
        if (!oneTimePaymentOffer && DetailUtils.getDetailInformation(app, 'AppVersion')) {
            usefulInformaionCells.push({
                id: 'AppVersion',
                title: 'App_Version',
                cellItems: [
                    {
                        id: 'AppVersionItem',
                        type: UsefulInfoMetadataCellItemType.Label,
                        text: DetailUtils.getDetailInformation(app, 'AppVersion')
                    }
                ]
            });
        }
        // app updated
        if (DetailUtils.getDetailInformation(app, 'ReleaseDate')) {
            usefulInformaionCells.push({
                id: 'ReleaseDate',
                title: 'App_Updated',
                cellItems: [
                    {
                        id: 'AppReleaseDateItem',
                        type: UsefulInfoMetadataCellItemType.Label,
                        text: this.context.locDateString(DetailUtils.getDetailInformation(app, 'ReleaseDate'))
                    }
                ]
            });
        }
        if (!oneTimePaymentOffer && this.props.app.products && Object.keys(this.props.app.products).length > 0) {
            // products
            const products = this.getProductFilterListElements(Constants.filterMaps.products, Constants.filterTileTypes.product).map((product)=>{
                return {
                    id: product.title,
                    type: UsefulInfoMetadataCellItemType.Filter,
                    text: product.locKey,
                    entityId: app.entityId,
                    filter: product,
                    isEmbedded: false,
                    nationalCloud: this.props.nationalCloud
                };
            });
            usefulInformaionCells.push({
                id: 'FilterType_Products',
                title: 'FilterType_Products',
                cellItems: products
            });
        }
        // categories
        const primaryProductFilter = getProductFilter(app.primaryProduct);
        const categories = this.getFilterListInfoElements({
            filterType: Constants.filterTileTypes.category,
            filterItem: Constants.filterMaps.categories,
            details: app.categoriesDetails,
            primaryProductFilter
        });
        if (categories === null || categories === void 0 ? void 0 : categories.length) {
            usefulInformaionCells.push({
                id: 'Categories',
                title: 'App_Categories',
                cellItems: categories
            });
        }
        // industries
        const industries = this.getFilterListInfoElements({
            filterType: Constants.filterTileTypes.industry,
            filterItem: Constants.filterMaps.industries,
            details: app.industriesDetails
        });
        if (industries === null || industries === void 0 ? void 0 : industries.length) {
            usefulInformaionCells.push({
                id: 'Industries',
                title: 'App_Industries',
                cellItems: industries
            });
        }
        // Work with - Products supported
        const worksWith = this.getOfficeWorksWithList('WorksWith');
        if (worksWith && worksWith.length) {
            const products = worksWith.map((productName)=>{
                return {
                    id: 'WorksWith' + productName,
                    type: UsefulInfoMetadataCellItemType.Label,
                    text: productName
                };
            });
            if (products.length) {
                usefulInformaionCells.push({
                    id: 'WorksWith',
                    title: 'App_WorksWith',
                    cellItems: products
                });
            }
        }
        // ### Support section ###
        // support
        if (DetailUtils.getDetailInformation(this.props.app, 'SupportLink') || DetailUtils.getDetailInformation(this.props.app, 'HelpLink')) {
            const supportitems = [];
            if (DetailUtils.getDetailInformation(this.props.app, 'SupportLink')) {
                supportitems.push({
                    information: DetailUtils.getDetailInformation(this.props.app, 'SupportLink'),
                    id: 'SupportLink',
                    text: 'App_Support',
                    type: UsefulInfoMetadataCellItemType.Link,
                    entityId: app.entityId
                });
            }
            if (DetailUtils.getDetailInformation(this.props.app, 'HelpLink')) {
                supportitems.push({
                    information: DetailUtils.getDetailInformation(this.props.app, 'HelpLink'),
                    id: 'HelpLink',
                    text: 'App_Help',
                    type: UsefulInfoMetadataCellItemType.Link,
                    entityId: app.entityId
                });
            }
            supportCells.push({
                id: 'supportLinks',
                title: null,
                cellItems: supportitems
            });
        }
        // Legal
        if (DetailUtils.getDetailInformation(app, 'PrivacyPolicyUrl') || app.licenseTermsUrl) {
            const cells = [
                ...this.getTermsOfUseLinks().map((link)=>{
                    return {
                        information: link.information,
                        id: link.id,
                        text: link.locString,
                        type: UsefulInfoMetadataCellItemType.Link,
                        entityId: app.entityId
                    };
                }),
                {
                    information: DetailUtils.getDetailInformation(this.props.app, 'PrivacyPolicyUrl'),
                    id: 'PrivacyPolicyUrl',
                    text: 'App_PrivacyPolicy',
                    type: UsefulInfoMetadataCellItemType.Link,
                    entityId: app.entityId
                }
            ];
            usefulInformaionCells.push({
                id: 'App_Legal',
                title: 'App_Legal',
                cellItems: cells
            });
        }
        // more links
        const documents = this.props.app.detailInformation.CollateralDocuments;
        if (documents && documents.length > 0) {
            const documentsCells = documents.map((doc)=>{
                return {
                    information: doc.DocumentUri,
                    id: 'LearnMore',
                    text: getWorkBreakEnabledString(doc.DocumentName),
                    type: UsefulInfoMetadataCellItemType.Link,
                    entityId: app.entityId
                };
            });
            moreLinksCells.push({
                id: 'App_LearnMoreTitle',
                title: '',
                cellItems: documentsCells
            });
        }
        // ### Power BI Visual Instructions
        if (isPowerBIVisualsApp(this.props.app) && isMigratedPowerBIVisual(this.props.app)) {
            const cells = [
                {
                    id: 'PowerBIVisual_Instructions',
                    type: UsefulInfoMetadataCellItemType.Label,
                    text: 'PowerBIVisual_DetailsAndSupport_Text'
                },
                {
                    type: UsefulInfoMetadataCellItemType.InternalLink,
                    information: '',
                    text: 'PowerBIVisual_Instructions',
                    onClick: ()=>this.openInstructionsModal()
                }
            ];
            powerBIVisualCells.push({
                id: 'PowerBIVisual_Instructions',
                title: '',
                cellItems: cells
            });
        }
        // create root metadata item
        if (usefulInformaionCells.length) {
            metadata.push({
                id: 'UsefulInformationDetails',
                title: 'AppDetail_UsefulInformaionDetails',
                titleFallback: 'Details',
                cells: usefulInformaionCells
            });
        }
        if (supportCells.length) {
            metadata.push({
                id: 'Support',
                title: 'AppDetail_Support',
                cells: supportCells
            });
        }
        if (moreLinksCells.length) {
            metadata.push({
                id: 'App_Links',
                title: 'App_Links',
                titleFallback: 'Links',
                cells: moreLinksCells
            });
        }
        if (powerBIVisualCells.length) {
            metadata.push({
                id: 'PowerBIVisual_DetailsAndSupport',
                title: this.context.loc('PowerBIVisual_DetailsAndSupport_Title'),
                cells: powerBIVisualCells
            });
        }
        return metadata;
    }
    renderStickyCard(tabsProps, tabsChilds) {
        return /*#__PURE__*/ _jsx("div", {
            ref: this.stickyCardRef,
            children: /*#__PURE__*/ _jsxs(StickyCard, {
                title: this.props.app.title,
                logoURL: this.props.app.iconURL ? this.props.app.iconURL : '',
                tabsProps: tabsProps,
                tabsChilds: tabsChilds,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "stickyCardPricing",
                        children: this.bulidStartingPriceElement({
                            pricingLinkClassName: 'light'
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "stickyCardButton",
                        children: this.getCTAElement()
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "stickyCardFavourite",
                        children: this.getUserFavouriteButton()
                    })
                ]
            })
        });
    }
    getChildContext() {
        return {
            getAppDetailsStickyCardHeight: ()=>{
                var _this_stickyCardRef_current, _this_stickyCardRef;
                return (_this_stickyCardRef = this.stickyCardRef) === null || _this_stickyCardRef === void 0 ? void 0 : (_this_stickyCardRef_current = _this_stickyCardRef.current) === null || _this_stickyCardRef_current === void 0 ? void 0 : _this_stickyCardRef_current.clientHeight;
            }
        };
    }
    handleScroll() {
        const curWindow = getWindow();
        const isPageScrolled = StickyCard.handleScroll(curWindow, AppDetails.pdpTabsId);
        if (this.state.isPageScrolled !== isPageScrolled) {
            this.setState({
                isPageScrolled
            });
        }
    }
    renderTabContent(tabChild) {
        const { app, billingCountryCode } = this.props;
        return /*#__PURE__*/ _jsxs(Stack, {
            className: contentStyles.tabsContainer,
            children: [
                /*#__PURE__*/ _jsx(Stack.Item, {
                    grow: true,
                    className: classNames({
                        [contentStyles.autoScrollTabContent]: tabChild.name === Constants.Tabs.PlansAndPrice
                    }),
                    children: tabChild.getContent()
                }),
                DetailUtils.shouldShowUserTerms({
                    app,
                    billingCountryCode
                }) && this.props.isHydrated && tabChild.name !== Constants.Tabs.Reviews && /*#__PURE__*/ _jsx(Stack.Item, {
                    tokens: consentDisclaimerTokens,
                    className: contentStyles.userTermsContainer,
                    children: /*#__PURE__*/ _jsx(UserTerms, {
                        app: app
                    })
                })
            ]
        });
    }
    renderImpl() {
        const { uiRole, entityId, userInfo, app } = this.props;
        const isOneTimePayment = isOneTimePaymentOffer(entityId);
        if (this.props.app) {
            const tabsProps = this.getTabsProps();
            const tabsChilds = this.getTabChildren();
            return /*#__PURE__*/ _jsx("div", {
                className: "ASdesktopAppDetails",
                itemScope: true,
                itemType: "https://schema.org/SoftwareApplication",
                role: "main",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "spza_detailContainer spza_partnerDetailContainer",
                    children: [
                        this.state.isPageScrolled ? this.renderStickyCard(tabsProps, tabsChilds) : null,
                        /*#__PURE__*/ _jsxs("div", {
                            className: contentStyles.pdpDetailsContainer,
                            children: [
                                this.getBreadcrumbElement(),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "detailContent",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "deatilPageContent",
                                        children: [
                                            /*#__PURE__*/ _jsxs(Card, {
                                                title: this.props.app.title,
                                                subtitle: this.context.locParams('By_Publisher', [
                                                    this.props.app.publisher
                                                ]),
                                                logoURL: DetailUtils.getDetailInformation(this.props.app, 'LargeIconUri'),
                                                children: [
                                                    this.props.isHydrated && !isOneTimePayment && this.props.app.products != null ? this.buildFilterElements(this.getProductFilterListElements(Constants.filterMaps.products, Constants.filterTileTypes.product)) : null,
                                                    /*#__PURE__*/ _jsxs(Stack, {
                                                        className: contentStyles.bagdeContainer,
                                                        tokens: {
                                                            childrenGap: 5
                                                        },
                                                        wrap: true,
                                                        horizontal: true,
                                                        children: [
                                                            isPrivateOffer(this.props.app.appType) && this.renderBadge(Constants.BadgeType.PrivateOffer),
                                                            this.isFreeTrial() && this.renderBadge(Constants.BadgeType.FreeTrial),
                                                            this.isMicrosoftCertified() && this.renderBadge(Constants.BadgeType.MicrosoftCertified),
                                                            isCertifiedSoftware(app) && this.renderBadge(Constants.BadgeType.CertifiedSoftware),
                                                            this.props.app.isSolutionMap && this.renderBadge(Constants.BadgeType.SolutionMap),
                                                            this.hasOfficeAwards() && this.renderBadge(Constants.BadgeType.OfficeAwards),
                                                            this.isPBICertified() && this.renderBadge(Constants.BadgeType.PBICertified),
                                                            this.isMSPApp() && this.renderBadge(Constants.BadgeType.AzureExpertsMSP),
                                                            app.AzureBenefitEligible && this.renderBadge(Constants.BadgeType.AzureBenefitEligible)
                                                        ]
                                                    }),
                                                    this.renderRatings(),
                                                    this.renderLinkedIn(),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "container",
                                                        children: [
                                                            this.props.isHydrated && this.bulidStartingPriceElement({
                                                                pricingLinkClassName: 'dark'
                                                            }),
                                                            this.getCTAElement(),
                                                            isPowerBIVisualsApp(this.props.app) && isMigratedPowerBIVisual(this.props.app) && this.getDownloadSampleButton(),
                                                            isPowerBIVisualsApp(this.props.app) && isMigratedPowerBIVisual(this.props.app) && this.getInstructionsButton(),
                                                            this.getUserFavouriteButton()
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx(MicrosoftManagedIndicatorWrapper, {
                                                        app: this.props.app,
                                                        isAvailableInRegion: isAvailableInThisRegion(this.props),
                                                        uiRole: uiRole,
                                                        renderIndicator: this.getMicrosoftManagedIndicator.bind(this)
                                                    }),
                                                    !isAvailableInThisRegion(this.props) && this.getNotAvailableInRegionText()
                                                ]
                                            }),
                                            this.props.isHydrated && /*#__PURE__*/ _jsx(_Fragment, {
                                                children: this.renderLinkedItems(this.props.app, this.props.nationalCloud)
                                            }),
                                            !this.props.app.detailInformation ? null : /*#__PURE__*/ _jsx("div", {
                                                id: AppDetails.pdpTabsId,
                                                className: AppDetails.pdpTabsClass,
                                                children: /*#__PURE__*/ _jsx(Tabs, {
                                                    defaultTab: tabsProps.defaultTab,
                                                    ownerType: tabsProps.ownerType,
                                                    ownerId: tabsProps.ownerId,
                                                    changeTabCallback: tabsProps.changeTabCallback,
                                                    getTabHref: tabsProps.getTabHref,
                                                    children: tabsChilds.map((tabChild)=>/*#__PURE__*/ _jsx(Tab, {
                                                            title: tabChild.title,
                                                            name: tabChild.name,
                                                            textBadge: tabChild.textBadge,
                                                            children: this.renderTabContent(tabChild)
                                                        }, tabChild.name))
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            });
        }
        if (!userInfo.privateOffers.loading && !userInfo.privateOffers.dataList.find((offer)=>offer.entityId === entityId)) {
            return this.renderEmptyPrivatePage();
        } else {
            // there is no app
            return /*#__PURE__*/ _jsx(Spinner, {
                className: "nullAppContainer",
                children: this.context.loc('AppDetail_LoadingText', 'Loading...')
            });
        }
    }
    constructor(props, context){
        super(props, context), _define_property(this, "stickyCardRef", null), _define_property(this, "instrument", void 0), _define_property(this, "context", void 0), _define_property(this, "getFilterListInfoElements", ({ filterType, filterItem, details, primaryProductFilter })=>{
            const { app } = this.props;
            return details === null || details === void 0 ? void 0 : details.map(({ urlKey, longTitle, locKey })=>{
                const pathParams = {
                    [filterType]: urlKey,
                    product: primaryProductFilter === null || primaryProductFilter === void 0 ? void 0 : primaryProductFilter.UrlKey
                };
                const newPath = this.context.buildHref(routes.marketplace, null, pathParams);
                const filter = {
                    filterItem,
                    locKey,
                    newPath,
                    title: longTitle,
                    urlKey
                };
                return {
                    id: filter.title,
                    type: UsefulInfoMetadataCellItemType.Filter,
                    text: filter.locKey,
                    entityId: app.entityId,
                    filter,
                    isEmbedded: false,
                    nationalCloud: this.props.nationalCloud
                };
            });
        }), _define_property(this, "openInstructionsModal", ()=>{
            if (this.props.app.downloadLink) {
                this.props.openInstructionsModal();
            }
        }), _define_property(this, "getItNowTableCallback", (planId)=>{
            const { app, ribbonKey, setCheckoutSourcePDP } = this.props;
            setCheckoutSourcePDP({
                source: CheckoutSource.PdpTable
            });
            this.context.ctaCallback({
                entity: app,
                entityType: Constants.EntityType.App,
                ctaType: app.ctaTypes[0],
                skuId: null,
                actionModifier: Constants.Telemetry.ActionModifier.AppDetailCTAButtonFromTable,
                tileDataRequestId: null,
                hasLicense: this.props.doesTenantHasLicenseForApp,
                planId,
                ribbonKey
            });
        });
        this.instrument = SpzaInstrumentService.getProvider();
        this.stickyCardRef = /*#__PURE__*/ React.createRef();
        this.state = {
            isPageScrolled: false,
            pageLoadLogged: false
        };
    }
}
_define_property(AppDetails, "pricingTabName", 'PlansAndPrice');
_define_property(AppDetails, "pdpTabsId", 'pdpTabs');
_define_property(AppDetails, "pdpTabsClass", 'pdpTabs');
AppDetails.childContextTypes = {
    getAppDetailsStickyCardHeight: PropTypes.func
};
AppDetails.contextTypes = {
    loc: PropTypes.func,
    locDateString: PropTypes.func,
    locParams: PropTypes.func,
    buildHref: PropTypes.func,
    ctaCallback: PropTypes.func,
    contactCallback: PropTypes.func,
    renderErrorModal: PropTypes.func,
    openTileCallback: PropTypes.func
};
